module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d85331a416a9a79b829ced3d0e104e88.png";